import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'


export const LeadDetailsInfoComponent = ({ handleInnerFormChange,tagNames,salutation,businessType,industryType,salesSource,leadRating,leadStatus,selectedLead,campaign, accounts, taskStatus, chosenActivity, getStatusName }: any) => {

  
  return (
  <>
    <AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
                label="Salutation"
                labelField="Text"
                list={salutation}
                onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.Salutation',
                    selectedLead?.LeadInformation
                    );
                }}
                optionName='Choose Persion Title'
                type="select"
                value={selectedLead?.LeadInformation?.Salutation}
                valueField="Value"
            />
            <InputContainer
                label="FirstName"
                name="FirstName"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.FirstName',
                    selectedLead?.LeadInformation
                    )
                }}
                type="text"
                value={selectedLead?.LeadInformation?.FirstName}
            />
        
            <InputContainer
                label="LastName"
                name="LastName"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.LastName',
                    selectedLead?.LeadInformation

                    )
                }}
                type="text"
                value={selectedLead?.LeadInformation?.LastName}
            />
                
            <InputContainer
                label="Email"
                name="Email"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.Email',
                    selectedLead?.LeadInformation

                    )
                }}
                type="text"
                value={selectedLead?.LeadInformation?.Email}
            />
            <InputContainer
                label="Phone"
                name="Phone"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.Phone',
                    selectedLead?.LeadInformation
                    )
                }}
                type="number"
                value={selectedLead?.LeadInformation?.Phone}
            />
                
            <InputContainer
                label="Mobile"
                name="Mobile"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.Mobile',
                    selectedLead?.LeadInformation
                    )
                }}
                type="number"
                value={selectedLead?.LeadInformation?.Mobile}
            />
                
            {/* <InputContainer
                label="Fax"
                name="Fax"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.Fax',
                    selectedLead?.LeadInformation
                    )
                }}
                type="number"
                value={selectedLead?.LeadInformation?.Fax}
            /> */}
                
            <InputContainer
                label="Title"
                name="Title"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.Title',
                    selectedLead?.LeadInformation
                    )
                }}
                type="text"
                value={selectedLead?.LeadInformation?.Title}
            />
            
            <InputContainer
                label="Website"
                name="Website"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.Website',
                    selectedLead?.LeadInformation

                    )
                }}
                type="text"
                value={selectedLead?.LeadInformation?.Website}
            />
            <InputContainer
                label="Company"
                name="Company"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                    event.target.value,
                    'LeadInformation.Company',
                    selectedLead?.LeadInformation
                    )
                }}
                type="text"
                value={selectedLead?.LeadInformation?.Company}
            />
        
        </div>
      }
      expandedPanel="Basic Info"
      headerTitle="Basic Info"
    />
    <AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
                        label="Industry"
                        labelField="Text"
                        list={industryType}
                        onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'LeadAdditionalInformation.Industry',
                            selectedLead?.LeadAdditionalInformation
                          );
                        }}
                        optionName='Choose Industy Type'
                        type="select"
                        value={selectedLead?.LeadAdditionalInformation?.Industry}
                        valueField="Value"
                    />

                   <InputContainer
                        label="BusinessType"
                        labelField="Description"
                        list={businessType}
                        onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'LeadAdditionalInformation.BusinessTypeId',
                            selectedLead?.LeadAdditionalInformation
                          );
                        }}
                        optionName='Choose Business Type'
                        type="select"
                        value={selectedLead?.LeadAdditionalInformation?.BusinessTypeId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="AnnualRevenue"
                        name="AnnualRevenue"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'LeadAdditionalInformation.AnnualRevenue',
                            selectedLead?.LeadAdditionalInformation
                          )
                        }}
                        type="number"
                        value={selectedLead?.LeadAdditionalInformation?.AnnualRevenue}
                    />
                
                    <InputContainer
                        label="NumberEmployees"
                        name="NumberEmployees"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'LeadAdditionalInformation.NumberEmployees',
                            selectedLead?.LeadAdditionalInformation

                          )
                        }}
                        type="number"
                        value={selectedLead?.LeadAdditionalInformation?.NumberEmployees}
                    />
                
                    <InputContainer
                        label="Source"
                        labelField="Text"
                        list={salesSource}
                        onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'LeadAdditionalInformation.Source',
                            selectedLead?.LeadAdditionalInformation
                          );
                        }}
                        optionName='Choose Sales Source'
                        type="select"
                        value={selectedLead?.LeadAdditionalInformation?.Source}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Rating"
                        labelField="Text"
                        list={leadRating}
                        onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'LeadAdditionalInformation.Rating',
                            selectedLead?.LeadAdditionalInformation
                          );
                        }}
                        optionName='Choose Lead Rating'
                        type="select"
                        value={selectedLead?.LeadAdditionalInformation?.Rating}
                        valueField="Value"
                    />

                
                    <InputContainer
                        label="Status"
                        labelField="Text"
                        list={leadStatus}
                        onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'LeadAdditionalInformation.Status',
                            selectedLead?.LeadAdditionalInformation
                          );
                        }}
                        optionName='Choose Lead Stauts'
                        type="select"
                        value={selectedLead?.LeadAdditionalInformation?.Status}
                        valueField="Value"
                    />

                
                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'LeadAdditionalInformation.Description',
                            selectedLead?.LeadAdditionalInformation

                          )
                        }}
                        row={4}
                        type="text"
                        value={selectedLead?.LeadAdditionalInformation?.Description}
                    />
        
        </div>
     }
     expandedPanel="Additional Info"
     headerTitle="Additional Info"
   />
   <AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
                  label="Tag"
                 labelField="displayText"
                 list={tagNames}
                 onValueChange={(event: any, newValue: any) => {
                     handleInnerFormChange(
                     event.target.value,
                     'TagEntityMappingsValueIds',
                         );
                     }}
                 optionName='Choose Lead Tag' 
                 type="select"
                 value={selectedLead?.TagEntityMappingsValueIds}
                 valueField="ValueId"
              />
           
         
        </div>
     }
     expandedPanel="Lead Tag"
     headerTitle="Lead Tag"
   />
  </>
  )
}
export default LeadDetailsInfoComponent;
